import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface DailyMemoDatesResponse {
    dates: string[]; // 'YYYY-MM-DD'
}

/*
// 메모가 있는 날짜 목록
// 달력에 점을 찍는 용도라 보이는 달의 범위만 받아온다.
*/
export const useGetDailyMemoDates = (start_date: string, end_date: string): UseQueryResult<DailyMemoDatesResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<DailyMemoDatesResponse, Error>({
        queryKey: ["getDailyMemoDates", start_date, end_date],
        enabled: !!start_date && !!end_date,
        queryFn: async () => {
            const response = await axios.get(enum_api_uri.daily_memo_dates, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: { start_date, end_date },
            });
            return response.data.data;
        },
    });
};
